import React from 'react';

const RMMContext = React.createContext('rmm');

export const RMMContextProvider = RMMContext.Provider;

export default RMMContext;
